module.exports = __webpack_public_path__ + "img/PRprinting5.1e25ad21.png";